import { guideSteps } from '@/mocks/home';

export default function GuideSection() {
  return (
    <section id="guide" className="w-full bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="max-w-2xl">
          <span className="text-xs md:text-sm font-semibold uppercase tracking-widest text-accent-600">
            How To Start
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            第一次使用，可以按这四步来
          </h2>
          <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-700">
            从确认入口到开启字幕，下面的流程覆盖了最常见的操作顺序，跟着做基本不会卡住。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {guideSteps.map((s, idx) => (
            <article
              key={s.step}
              className="relative rounded-lg border border-background-200 bg-background-100/60 p-5 md:p-6"
            >
              <span className="font-heading text-3xl md:text-4xl font-black text-background-300">
                {s.step}
              </span>
              <h3 className="mt-3 font-heading text-base md:text-lg font-bold text-foreground-950">
                {s.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-700">{s.desc}</p>
              {idx < guideSteps.length - 1 && (
                <i className="ri-arrow-right-line absolute right-4 top-5 hidden lg:block text-background-400"></i>
              )}
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}